/** URL boundaries mirror the server PagePermissionPolicy; unknown KiERA routes deny access. */
const PAGE_KEYS: Record<string, string> = {
    "/kiera/nodes/api-register": "api_node_registration",
    "/kiera/management-settings": "management_settings",
    "/kiera/provisioning-rack": "provisioning_rack_view",
    "/kiera/operations-rack": "operations_rack_view",
    "/kiera/bmc-credentials": "bmc_credentials",
    "/kiera/cluster-deploy": "cluster_deploy",
    "/kiera/cluster-users": "cluster_users",
    "/kiera/bmc-discovery": "bmc_discovery",
    "/kiera/ssh-access": "ssh_access",
    "/kiera/log-policy": "log_policy",
    "/kiera/resourcerack": "rack_view",
    "/kiera/assistant": "assistant",
    "/kiera/clusters": "clusters",
    "/kiera/subnets": "subnets",
    "/kiera/diskless": "diskless",
    "/kiera/actions": "actions",
    "/kiera/chassis": "chassis",
    "/kiera/scripts": "script_config",
    "/kiera/terminal": "nodes",
    "/kiera/zabbix": "zabbix",
    "/kiera/groups": "groups",
    "/kiera/images": "images",
    "/kiera/inspect": "inspect",
    "/kiera/relay": "cluster_deploy",
    "/kiera/lustre": "lustre",
    "/kiera/swagger": "public_api",
    "/kiera/status": "dashboard",
    "/kiera/debug": "debug",
    "/kiera/nodes": "nodes",
    "/kiera/zones": "zones",
    "/kiera/help": "help",
    "/kiera/jobs": "job_management",
    "/kiera/logs": "service_logs",
    "/kiera/juju": "juju",
    "/kiera/keys": "key_management",
    "/kiera/sol": "nodes",
    "/kiera/pe": "pe",
    "/members": "members",
    "/kiera": "dashboard"
};
export function pagePermissionKey(url: string): string | null {
    let path: string;
    try {
        path = decodeURIComponent(String(url || '/').split(/[?#]/, 1)[0])
            .split('/').map(segment => segment.split(';', 1)[0]).join('/').replace(/\/+$/, '') || '/';
    } catch {
        return '!unmapped';
    }
    if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')
        || /[\u0000-\u001f]/.test(path) || path.split('/').some(segment => segment === '..' || segment === '.')) return '!unmapped';
    const entry = Object.entries(PAGE_KEYS)
        .sort((a, b) => b[0].length - a[0].length)
        .find(([prefix]) => path === prefix || (prefix !== '/kiera' && path.startsWith(prefix + '/')));
    if (entry) return entry[1];
    return path.startsWith('/kiera/') ? '!unmapped' : null;
}
